module.exports = __webpack_public_path__ + "img/game-icon-act.d67d968c.png";